import { render } from "./AsahiSelectBox.vue?vue&type=template&id=66a13e22&scoped=true&ts=true"
import script from "./AsahiSelectBox.vue?vue&type=script&lang=ts"
export * from "./AsahiSelectBox.vue?vue&type=script&lang=ts"

import "./AsahiSelectBox.vue?vue&type=style&index=0&id=66a13e22&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a13e22"]])

export default __exports__